import React from 'react';

import NoResultsMessage from 'app/components/general/NoResultsMessage';
import {gt} from 'app/utils/i18n';

interface Props {
  error: any;
}

export const GuestTaskErrorPage = ({error}: Props): JSX.Element => {
  return (
    <NoResultsMessage
      icon="fa-exclamation-triangle text-warning"
      head={
        error.status === 404
          ? gt('Task not found')
          : gt('Error loading the task')
      }
    >
      <p className="lead mb-0">
        {gt(
          'Please contact the account manager and request a new link to the task.'
        )}
      </p>
    </NoResultsMessage>
  );
};
